import { createReducer, on, createSelector } from '@ngrx/store';
import { LoadTermsOfPayment, LoadTermsOfPaymentSuccess, LoadTermsOfPaymentFailure } from '../actions/terms-of-payment.actions';
import { TermsOfPaymentDTO } from '@iota/iota-management-portal-v4-client';
import { AppState } from '../store';

export interface TermsOfPaymentState {
    data: TermsOfPaymentDTO[] | null;
    loading: boolean;
    error: boolean;
}

export const initialState: TermsOfPaymentState = {
    data: null,
    loading: false,
    error: false
};

export const termsOfPaymentReducer = createReducer(
    initialState,
    on(LoadTermsOfPayment, (state) => ({ ...state, loading: true })),
    on(LoadTermsOfPaymentSuccess, (state, { data }) => ({ ...state, data, loading: false })),
    on(LoadTermsOfPaymentFailure, (state) => ({ ...state, loading: false, error: true }))
);

export const termsOfPaymentState = (state: AppState) => state.termsOfPaymentState;

export const termsOfPaymentData = createSelector(termsOfPaymentState, (state: TermsOfPaymentState) => state.data);
